module.exports = __webpack_public_path__ + "static/grafika5-8d9850e468139f333e73442f9b9274b1.png";